<header>
  <img routerLink="/" [src]="clinicLogo" alt="Clinic logo" [class.default]="clinicLogo === logo">

  @if (loggedIn) {
    <div class="welcome-container">
      <span class="welcome"><span class="welcometext">Welcome</span> {{ patient.FirstName }} {{ patient.LastName }}</span>
      <app-side-menu [user]="patient"></app-side-menu>
    </div>
  }

</header>